window.DR = window.DR || {};

const resolveByCountry = require('@dc/ui-library/src/helpers/environment').resolveByCountry;
const initFixedToolbar = require('../ui/fixed-toolbar.js');
const initSiteCatalystAjax = require('../ui/site-catalyst-ajax.js');
const fixedSide = require('../ui/fixed-side.js');
const initListDisplay = require('../ui/init-list-display.js');
const submitClone = require('../ui/submit-clone.js');

// old header for Currys Ireland
const OldHeader = require('../components/react/PageHeader/OldHeader').default;

// new header for Currys UK
const NewHeader = require('../components/react/PageHeader/NewHeader').default;

const Footer = require('../components/react/Footer/Footer').default;

const Simpletabs = require('../ui/simple-tabs.js');

window.DR.checkAddrSwitch = require('../ui/check-addr-switch.js');
window.DR.AddrLookup = require('../ui/addr-lookup.js').addrLookup;
window.DR.fillFormWithData = require('../ui/fill-form-with-data.js');

const googleMaps = require('../ui/google-maps.js');

window.DR.loadGMap = googleMaps.loadGMap;
window.DR.geocode = googleMaps.geocode;

module.exports = {
  DOMReadyInit: function DOMReadyInit() {
    if (typeof window.DR.initAB === 'function') {
      // TODO: UIDEV -> not sure if this function is ever called,
      // TODO: method call not found in fo-site and fo-site-ui.
      window.DR.initAB();
    }

    // changing location of features links above breadcrumb in DOM
    // when new header is used for UK Currys
    if (resolveByCountry(true, false)) {
      const features$ = $('#desktop-nav ul.features');

      if (features$.length === 1) {
        $('div#content').prepend(features$.remove());
      }
    }

    if ($('#formSubmit').length > 0) {
      submitClone('#formSubmit', '#formSubmitClone');
    }

    $('select').each(function each() {
      const select = $(this);
      select.click(() => {
        select.focus();
      });
    });

    if (typeof window.initializeGMAP === 'undefined' && $('input.geocode').length > 0) {
      window.initializeGMAP = function initializeGMAP() {
        window.DR.geocode('input.geocode');
      };
      if ($('#googleMapsScript').length === 0) {
        window.DR.loadGMap();
      }
    }

    if ($('.tabbed-content').length) {
      $('.tabbed-content').each(function each() {
        const thisTabs = new Simpletabs($(this)[0]); // eslint-disable-line no-unused-vars
      });
    }

    initSiteCatalystAjax(window.s, window.scData || []);
  },
  init: function init(initHeader = true) {
    initFixedToolbar();
    fixedSide('#fixed');
    initListDisplay('.shopList', 2);

    if (initHeader) {
      if (resolveByCountry(true, false)) {
        NewHeader.init();
      } else {
        OldHeader.init();
      }
    }

    if (resolveByCountry(true, false)) {
      Footer.init();
    }
  }
};
